import Sidebar from './Sidebar';

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/ProductsPage/components/Sidebar/index.js